// Terms and Conditions - Sync checkbox to hidden input
(function() {
  
  function syncCheckboxToHiddenInput() {
    const checkbox = document.getElementById('terms_acknowledged');
    const form = document.getElementById('cart');
    
    if (!checkbox || !form) return;
    
    // Create or find hidden input
    let hiddenInput = form.querySelector('input[name="attributes[Terms Acknowledged]"]');
    
    if (!hiddenInput) {
      hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'attributes[Terms Acknowledged]';
      form.appendChild(hiddenInput);
    }
    
    // Update hidden input value
    function updateHiddenInput() {
      hiddenInput.value = checkbox.checked ? 'Yes' : 'No';
    }
    
    // Initial sync
    updateHiddenInput();
    
    // Sync on change
    checkbox.addEventListener('change', updateHiddenInput);
    
    // Visual error handling
    checkbox.addEventListener('change', function() {
      const container = document.getElementById('terms-agreement');
      const errorMsg = document.getElementById('terms-error');
      
      if (this.checked) {
        if (container) container.classList.remove('has-error');
        if (errorMsg) errorMsg.style.display = 'none';
        this.setAttribute('aria-invalid', 'false');
      }
    });
  }
  
  // Validate on form submit
  function setupValidation() {
    const form = document.getElementById('cart');
    const checkbox = document.getElementById('terms_acknowledged');
    
    if (!form || !checkbox) return;
    
    form.addEventListener('submit', function(e) {
      if (!checkbox.checked) {
        e.preventDefault();
        e.stopPropagation();
        
        // Show error
        const container = document.getElementById('terms-agreement');
        const errorMsg = document.getElementById('terms-error');
        
        if (container) container.classList.add('has-error');
        if (errorMsg) {
          errorMsg.style.display = 'flex';
          errorMsg.setAttribute('aria-live', 'assertive');
        }
        checkbox.setAttribute('aria-invalid', 'true');
        
        // Scroll to checkbox
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        
        if (container) {
          container.scrollIntoView({ 
            behavior: prefersReducedMotion ? 'auto' : 'smooth',
            block: 'center' 
          });
        }
        
        setTimeout(function() {
          checkbox.focus();
        }, prefersReducedMotion ? 0 : 300);
        
        return false;
      }
    });
  }
  
  // Keyboard support for custom checkbox
  function setupKeyboard() {
    const checkbox = document.getElementById('terms_acknowledged');
    if (!checkbox) return;
    
    checkbox.addEventListener('keydown', function(e) {
      if (e.key === ' ' || e.keyCode === 32) {
        e.preventDefault();
        this.checked = !this.checked;
        this.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
  
  // Initialize
  function init() {
    syncCheckboxToHiddenInput();
    setupValidation();
    setupKeyboard();
  }
  
  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();